(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bdz-otp-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdz-otp-purchase')) {
  customElements.define('bdz-otp-purchase', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.querySelector('button').addEventListener('click', () => this.add(), {signal:this.events.signal});
    }
    async add() {
      if (document.querySelector('bdz-otp-purchase[aria-busy="true"]')) return;
      const button = this.querySelector('button');
      const error = this.querySelector('[role="alert"]');
      const status = this.querySelector('[role="status"]');
      const label = button.textContent;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const controls = [...document.querySelectorAll('bdz-otp-purchase button')];
      const states = controls.map(control => control.disabled);
      this.setAttribute('aria-busy','true');
      controls.forEach(control => control.disabled = true);
      button.textContent = this.dataset.adding;
      error.hidden = true;
      status.textContent = '';
      try {
        const body = {items:[{id:Number(this.dataset.variantId),quantity:1,properties:{'Purchase option':'One-time purchase'}}]};
        if (cart) {
          body.sections = cart.getSectionsToRender().map(section => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(button);
        }
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js?kaching_bundles=true`, {
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate,{source:'bdz-otp-purchase',productVariantId:this.dataset.variantId,cartData:result});
        }
        if (cart) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else window.location.assign(`${root}cart`);
        status.textContent = this.dataset.added;
      } catch (failure) {
        error.textContent = failure.message || this.dataset.error;
        error.hidden = false;
      } finally {
        this.removeAttribute('aria-busy');
        controls.forEach((control,index) => control.disabled = states[index]);
        button.textContent = label;
      }
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bdz-progressive-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdz-progressive-gifts')) {
  customElements.define('bdz-progressive-gifts', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.setup(), {once:true,signal:this.events.signal});
      else this.setup();
    }
    setup() {
      this.source = document.querySelector('.shop-product-layout');
      if (!this.source) return;
      const shippingPrice = this.querySelector('[data-shipping-usd-cents]');
      const rate = Number(window.Shopify?.currency?.rate);
      if (shippingPrice && window.Shopify?.currency?.active === 'AUD' && Number.isFinite(rate) && rate > 0) {
        const cents = Math.round(Number(shippingPrice.dataset.shippingUsdCents) * rate);
        shippingPrice.textContent = new Intl.NumberFormat('en-US', {style:'currency', currency:'AUD'}).format(cents / 100);
      }
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.observer = new MutationObserver(records => {
        if (records.some(record => !record.target.closest?.('bdz-progressive-gifts'))) this.schedule();
      });
      this.observer.observe(this.source,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','aria-checked','checked']});
      this.source.addEventListener('change',this.schedule,{signal:this.events.signal});
      this.sync();
    }
    sync() {
      const selected = this.source.querySelector('.kaching-bundles__bar--selected');
      if (!selected) return;
      const title = selected.querySelector('.kaching-bundles__bar-title')?.textContent || '';
      const match = title.match(/Get\s+(\d+)\s+FREE/i);
      const bottles = match ? Math.min(2, Number(match[1])) : 0;
      if (bottles === this.state) return;
      this.state = bottles;
      [1,2].forEach(number => {
        const item = this.querySelector(`[data-gift="bottle-${number}"]`);
        const unlocked = bottles >= number;
        item.dataset.unlocked = String(unlocked);
        item.querySelector('.bdz-gifts__content').setAttribute('aria-hidden',String(!unlocked));
        item.querySelector('.bdz-gifts__lock').setAttribute('aria-hidden',String(unlocked));
      });
      const status = this.querySelector('.bdz-gifts__status');
      const shipping = this.querySelector('[data-gift="shipping"] .bdz-gifts__shipping-label').textContent.trim();
      const bottleLabel = this.querySelector('.bdz-gifts__reward-label').textContent.trim();
      status.textContent = `${shipping}: ${status.dataset.unlocked}. ${bottleLabel} 1: ${bottles >= 1 ? status.dataset.unlocked : status.dataset.locked}. ${bottleLabel} 2: ${bottles >= 2 ? status.dataset.unlocked : status.dataset.locked}.`;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bdz-purchase-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdz-price-sync')) {
  customElements.define('bdz-price-sync', class extends HTMLElement {
    connectedCallback() {
      this.column = this.closest('.shop-product-info');
      if (!this.column) return;
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.column,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled','aria-busy']});
      this.sync();
    }
    sync() {
      const button = this.column.querySelector('.shop-add-to-cart-button');
      if (!button) return;
      const selected = this.column.querySelector('.kaching-bundles__bar--selected');
      const price = selected?.querySelector('.kaching-bundles__bar-price')?.textContent.trim() || this.dataset.price;
      const compare = selected?.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim() || this.dataset.compare;
      let pill = button.querySelector('.bdz-button-prices');
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'bdz-button-prices';
        const original = document.createElement('s');
        original.className = 'bdz-button-compare';
        const current = document.createElement('span');
        current.className = 'bdz-button-price';
        pill.append(original,current);
        button.append(pill);
      }
      const current = pill.querySelector('.bdz-button-price');
      const original = pill.querySelector('.bdz-button-compare');
      if (current.textContent !== price) current.textContent = price;
      if (original.textContent !== compare) original.textContent = compare;
      original.hidden = !compare || compare === price || !/[1-9]/.test(compare);
      pill.hidden = button.disabled || button.getAttribute('aria-busy') === 'true';
      if (!button.querySelector('.bdz-button-arrow')) {
        const arrow = document.createElement('span');
        arrow.className = 'bdz-button-arrow';
        arrow.setAttribute('aria-hidden','true');
        arrow.textContent = '→';
        button.append(arrow);
      }
      if (!button.classList.contains('bdz-price-button')) button.classList.add('bdz-price-button');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bdz-simple-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bdz-product-gallery')) {
  customElements.define('bdz-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bdz-gallery-track');
      this.thumbs = [...this.querySelectorAll('[data-bdz-index]')];
      this.index = 0;
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-bdz-index]');
        const step = event.target.closest('[data-bdz-step]');
        if (thumb) this.go(Number(thumb.dataset.bdzIndex));
        if (step) this.go(this.index + Number(step.dataset.bdzStep));
      }, {signal:this.events.signal});
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal:this.events.signal});
      this.track.addEventListener('scroll', () => {
        const next = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (next === this.index) return;
        this.index = next;
        this.thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === next)));
        const thumb = this.thumbs[next];
        if (thumb) thumb.parentElement.scrollTo({left:thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2, behavior:'smooth'});
      }, {passive:true,signal:this.events.signal});
    }
    go(index) {
      const next = (index + this.thumbs.length) % this.thumbs.length;
      this.track.scrollTo({left:next * this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
function bdzStickyInit() {
  const bar = document.querySelector('[data-bdz-sticky]');
  const button = document.querySelector('.shop-add-to-cart-button');
  if (bar && button) bar.hidden = button.getBoundingClientRect().bottom > 0;
}
document.addEventListener('DOMContentLoaded',bdzStickyInit);
window.addEventListener('scroll',bdzStickyInit,{passive:true});
window.addEventListener('resize',bdzStickyInit);
document.addEventListener('shopify:section:load',bdzStickyInit);
if (document.readyState !== 'loading') bdzStickyInit();
  } catch(e) { console.error(e); }
})();

})();
